import UnauthLayout from "./UnauthLayout";

export default UnauthLayout;
